Ext.define('SA.BeyondLimitPopup', {
    alias: 'widget.beyond-limit-popup',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-beyond-limit-popup',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-beyond-limit-popup-header',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-beyond-limit-popup-title',
                        html: 'Your Data Export Usage'
                    }, {
                        xtype: 'close-button'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-beyond-limit-popup-body',

                items: [
                    {
                        xtype: 'component',
                        autoEl: 'table',
                        cls: 'sa-beyond-limit-popup-table',
                        data: this.data,

                        tpl: [
                            '<thead>',
                                '<tr>',
                                    '<th></th>',
                                    '<th colspan="2">Weekly Limit</th>',
                                    '<th colspan="2">Yearly Limit</th>',
                                '</tr>',
                                '<tr>',
                                    '<th></th>',
                                    '<th>Already Used</th>',
                                    '<th>With this Export</th>',
                                    '<th>Already Used</th>',
                                    '<th>With this Export</th>',
                                '</tr>',
                            '</thead>',
                            '<tbody>',
                                '<tpl for=".">',
                                    '<tr>',
                                        '<td>{datasetName}</td>',
                                        '<td>{perWeek.usedPercent:formatValue("%01.2f%%")}</td>',
                                        '<td>{perWeek.wouldBeUsedPercent:formatValue("%01.2f%%")}</td>',
                                        '<td>{perYear.usedPercent:formatValue("%01.2f%%")}</td>',
                                        '<td>{perYear.wouldBeUsedPercent:formatValue("%01.2f%%")}</td>',
                                    '</tr>',
                                '</tpl>',
                            '</tbody>'
                        ]
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-beyond-limit-popup-footer'
            }
        ];

        this.callParent();
    }
});